import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerInformesConservacion = async (values) => {
    try {

        const resultado = await instance.Backend.post("/Autorizacion/ObtenerInformesConservacion",values, customConfig);
        
        return resultado
        
    } catch (error) {

        console.log(error);
    }
}
export { ObtenerInformesConservacion };